export const PERCENTAGE = 100;
